module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/sincerely_3x.1ad5d87.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/sincerely_3x.png
// module id = sA30
// module chunks = 41